






















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class BraveLauncherWarningBanner extends Vue {
  braveIcon: any = require('@/assets/logos/brave-logo.svg');

  get braveLauncherWarningBannerText() {
    return {
      headline: this.$t(`components.games.braveLauncherWarningBanner.headline`),
      subhead: this.$t(`components.games.braveLauncherWarningBanner.subhead`),
    };
  }
}
